import {setCookie} from "app/lib/cookies";
import {mapKeys, snakeCase} from 'lodash';
import {Amount} from "app/model/amount";
import * as jwt from 'jsrsasign';
import * as jwtDecode from 'jwt-decode';

export const CALCULATOR_COOKIE_NAME = 'predefined_transfer';

export class CalculatorCookieService {
    constructor(countryIn, countryOut, amountIn, amountOut, deliveryMethod) {
        if (!countryIn || !countryOut || !amountIn || !amountOut || !deliveryMethod) {
            throw new Error('You have to pass all parameters');
        }

        if (!(amountIn instanceof Amount) || !(amountOut instanceof Amount)) {
            throw new Error('amountIn/amountOut property should be Amount instance');
        }

        this.cookie = {
            countryFrom: countryIn,
            countryTo: countryOut,
            currencyIn: amountIn.getCurrency,
            amountIn: amountIn.getAmount,
            currencyOut: amountOut.getCurrency,
            amountOut: amountOut.getAmount,
            realizationMethod: deliveryMethod.name,
        }
    }

    static update(data) {
        const self = new CalculatorCookieService(
            data.countryIn,
            data.countryOut,
            data.amountIn,
            data.amountOut,
            data.deliveryMethod
        );
        const cookie = self._toUpdater(self.cookie);
        const token = self._createToken(cookie);

        return setCookie(CALCULATOR_COOKIE_NAME, token, 365);
    }

    static read(token, pubKey) {
        if (jwt.jws.JWS.verify(token, pubKey, ['HS256'])) {
            return jwtDecode(token);
        }

        return false;
    }

    /** @private */
    _createToken(data) {
        const header = JSON.stringify({typ: 'JWT', alg: 'HS256'});

        if (data.country_to === 'ua') {
            data.realization_method = 'inteli_express';
        }

        const payload = JSON.stringify(Object.assign({sub:CALCULATOR_COOKIE_NAME}, data));
        return jwt.jws.JWS.sign("HS256", header, payload, CALCULATOR_COOKIE_NAME);
    }

    /** @private */
    _toUpdater(cookie) {
        return mapKeys(cookie, (value, key) => snakeCase(key));
    }
}
